import React from "react";
import { useSelector } from "react-redux";
import {
	createBrowserRouter,
	createRoutesFromChildren,
	matchRoutes,
	Navigate,
	Outlet,
	useLocation,
	useNavigationType,
} from "react-router-dom";
import { ModalsProvider } from "@mantine/modals";
import * as Sentry from "@sentry/react";

import HyperAdminOtpModal from "components/Modals/HyperAdminOtpModal";
import OTPModal from "components/Modals/OtpModal";

import AuthLayout from "@/layouts/AuthLayout";
import NewsLayout from "@/layouts/News";
import AppWithProfile from "layouts/AppWithProfile";
import HomeApp from "layouts/HomeApp";

import HyperAdminUserSelection from "@/views/pages/auth/HyperAdminUserSelection";
import Login from "@/views/pages/auth/Login";
import Register from "@/views/pages/auth/Register";
import ResetPassword from "@/views/pages/auth/ResetPassword";
import ResetPasswordOtpValidation from "@/views/pages/auth/ResetPasswordOtpValidation";
import { CheckoutCourseSummaryPage } from "@/views/pages/checkout/CheckoutCourseSummaryPage";
import { CheckoutPage } from "@/views/pages/checkout/CheckoutPage";
import { CheckoutRegisterPage } from "@/views/pages/checkout/CheckoutRegisterPage";
import { CheckoutSuccessPage } from "@/views/pages/checkout/CheckoutSuccessPage";
import ErrorFallback from "@/views/pages/error/ErrorFallback";
import FCAHomeBundle from "@/views/pages/home/BundleInfo/BundleInfo";
import FCAHomeDashboard from "@/views/pages/home/Dashboard";
//avatar
import AvatarScreen from "@/views/pages/learner/avatar/AvatarScreen";
import { CertRequestPage } from "@/views/pages/learner/CertRequestPage";
import ContactUs from "@/views/pages/learner/course/ContactUs";
import ContactUs2 from "@/views/pages/learner/course/ContactUs2";
import CourserunDetail from "@/views/pages/learner/course/CourserunDetail";
import MealSuccessPage from "@/views/pages/learner/course/MealSuccessPage";
import ModalBundleInfo from "@/views/pages/learner/course/ModalBundleInfo";
import ModalBundleList from "@/views/pages/learner/course/ModalBundleList";
import ModalCertificates from "@/views/pages/learner/course/ModalCertificates";
import ModalConfirm from "@/views/pages/learner/course/ModalConfirm";
import ModalCourseInfo from "@/views/pages/learner/course/ModalCourseInfo";
import ModalDownloadResources from "@/views/pages/learner/course/ModalDownloadResources";
import ModalEndorse from "@/views/pages/learner/course/ModalEndorse";
import ModalMealSelection from "@/views/pages/learner/course/ModalMealSelection";
import ModalPayment from "@/views/pages/learner/course/ModalPayment";
import ModalRegistration from "@/views/pages/learner/course/ModalRegistration";
import ModalReschedule from "@/views/pages/learner/course/ModalReschedule";
import ModalRescheduleDesc from "@/views/pages/learner/course/ModalRescheduleDesc";
import ModalResourceDetails from "@/views/pages/learner/course/ModalResourceDetails";
import ModalShuttleBus from "@/views/pages/learner/course/ModalShuttleBus";
import ModalSuccess from "@/views/pages/learner/course/ModalSuccess";
import ModalWithdrawal from "@/views/pages/learner/course/ModalWithdrawal";
import ModalWithdrawalDesc from "@/views/pages/learner/course/ModalWithdrawalDesc";
import ShuttleBusSuccessPage from "@/views/pages/learner/course/ShuttleBusSuccessPage";
import SuccessPage from "@/views/pages/learner/course/SuccessPage";
import FCADashboard from "@/views/pages/learner/Dashboard";
import { EventAppCheckoutPage } from "@/views/pages/learner/event/checkout/EventAppCheckoutPage";
import { EventCheckout } from "@/views/pages/learner/event/checkout/EventCheckout";
import { EventCheckoutSuccessPage } from "@/views/pages/learner/event/checkout/EventCheckoutSuccessPage";
import { EventCheckoutSummaryPage } from "@/views/pages/learner/event/checkout/EventCheckoutSummaryPage";
import { EventOmiseloading } from "@/views/pages/learner/event/checkout/EventOmiseloading";
import EventOmisePaynow from "@/views/pages/learner/event/checkout/EventOmisePaynow";
import EventDetails from "@/views/pages/learner/event/EventDetails";
import EventHome from "@/views/pages/learner/event/EventHome";
// FAQ
import FaqMain from "@/views/pages/learner/faq/FaqMain";
import DailyNews from "@/views/pages/learner/news/DailyNews";
import DailyNewsDetails from "@/views/pages/learner/news/DailyNewsDetails";
import NewsHomeScreen from "@/views/pages/learner/news/NewsHomeScreen";
import Teaser from "@/views/pages/learner/news/Teaser";
import TeasersDetails from "@/views/pages/learner/news/TeasersDetails";
import ArticleReply from "@/views/pages/learner/notification/ArticleReply";
import NotificationDetails from "@/views/pages/learner/notification/NotificationDetails";
// Notification
import NotificationMain from "@/views/pages/learner/notification/NotificationMain";
import OmisePage from "@/views/pages/learner/Omise";
import Omiseloading from "@/views/pages/learner/Omiseloading";
import Omisepaynow from "@/views/pages/learner/Omisepaynow";
import Omisesuccess from "@/views/pages/learner/Omisesuccess";
import Profile from "@/views/pages/learner/profile/Profile";
import ProfileChangeEmail from "@/views/pages/learner/profile/ProfileChangeEmail";
import ProfileChangeEmailOtpValidation from "@/views/pages/learner/profile/ProfileChangeEmailOtpValidation";
import ProfileChangePassword from "@/views/pages/learner/profile/ProfileChangePassword";
import ProfileChangePasswordOtpValidation from "@/views/pages/learner/profile/ProfileChangePasswordOtpValidation";
import ProfileDeleteAccount from "@/views/pages/learner/profile/ProfileDeleteAccount";
import ProfileDeleteAccountOtpValidation from "@/views/pages/learner/profile/ProfileDeleteAccountOtpValidation";
import ProfileEdit from "@/views/pages/learner/profile/ProfileEdit";
// Referral
import ReferralDashboard from "@/views/pages/learner/referral/ReferralDashboard";
import VideoHome from "@/views/pages/learner/video/VideoHome";
import MaintenancePage from "@/views/pages/MaintenancePage";
import { ProfessionalCertAppCheckoutPage } from "@/views/pages/professional-cert/checkout/ProfessionalCertAppCheckoutPage";
import { ProfessionalCertCheckout } from "@/views/pages/professional-cert/checkout/ProfessionalCertCheckout";
import { ProfessionalCertCheckoutSuccessPage } from "@/views/pages/professional-cert/checkout/ProfessionalCertCheckoutSuccessPage";
import { ProfessionalCertCheckoutSummaryPage } from "@/views/pages/professional-cert/checkout/ProfessionalCertCheckoutSummaryPage";
import { ProfessionalCertOmiseloading } from "@/views/pages/professional-cert/checkout/ProfessionalCertOmiseloading";
import ProfessionalCertOmisePaynow from "@/views/pages/professional-cert/checkout/ProfessionalCertOmisePaynow";
import CreatePage from "@/views/pages/professional-cert/CreatePage";
import { ListingPage } from "@/views/pages/professional-cert/ListingPage";
import ViewCert from "@/views/pages/professional-cert/ViewCert";

import App from "./layouts/App";
import LoginBySession from "./views/pages/auth/LoginBySession";
import { MobileRedirectFail } from "./views/pages/redirect/mobile-redirection-fail";
import { MobileRedirectSuccess } from "./views/pages/redirect/mobile-redirection-success";

// MAINTENANCE MODE CONFIGURATION
// Maintenance mode is now controlled by the REACT_APP_MAINTENANCE_MODE environment variable
//
// TO ENABLE MAINTENANCE MODE: Set REACT_APP_MAINTENANCE_MODE=true in your .env file
// - All routes will redirect to /maintenance page
// - Users will see the maintenance page for all URLs
//
// TO DISABLE MAINTENANCE MODE: Set REACT_APP_MAINTENANCE_MODE=false in your .env file
// - Normal website functionality will be restored
// - All original routes will work as before
//
const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE === "true";

if (!process.env.NODE_ENV || process.env.NODE_ENV === "production") {
	Sentry.init({
		environment: process.env.REACT_APP_ENV,
		dsn: "https://89a455bc63784c09843589c1650963fe@o4503969180024832.ingest.sentry.io/4505079456989184",
		// integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
		integrations: [
			new Sentry.BrowserTracing({
				routingInstrumentation: Sentry.reactRouterV6Instrumentation(
					React.useEffect,
					useLocation,
					useNavigationType,
					createRoutesFromChildren,
					matchRoutes,
				),
			}),
			new Sentry.Replay(),
		],
		// Performance Monitoring
		tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
		// Session Replay
		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	});
}

function PrivateRoute({ children }) {
	const { user: currentUser } = useSelector((state) => state.auth);
	const location = useLocation();
	if (!currentUser) {
		// Save the attempted URL to redirect back after login
		const returnUrl = location.pathname + location.search;
		localStorage.setItem("intended_url", returnUrl);
		return <Navigate to="/login" />;
	}

	return children;
}

const MyRouteWrapper = () => {
	return (
		<ModalsProvider>
			<Outlet />
		</ModalsProvider>
	);
};

const route = [
	{
		path: "/",
		element: <MyRouteWrapper />,
		children: MAINTENANCE_MODE
			? [
					// MAINTENANCE MODE: All routes redirect to maintenance
					{
						path: "/maintenance",
						element: <MaintenancePage />,
					},
					{
						path: "/",
						element: <Navigate to="/maintenance" replace />,
					},
					{
						path: "*",
						element: <Navigate to="/maintenance" replace />,
					},
			  ]
			: [
					// NORMAL OPERATION MODE - All routes below are active
					// new landing page home
					{
						path: "/",
						element: (
							<Sentry.ErrorBoundary fallback={({ error }) => <ErrorFallback error={error} />}>
								<HomeApp />
							</Sentry.ErrorBoundary>
						),
						children: [
							{
								path: "/",
								element: <Navigate to="course" replace />,
							},
							// {
							// 	path: "/home",
							// 	element: <FCAHomeDashboard />,
							// 	children: [],
							// },
							{
								path: "/bundle/:id",
								element: <FCAHomeBundle />,
								children: [],
							},
							{
								path: "/course",
								element: (
									<PrivateRoute>
										<FCADashboard />
									</PrivateRoute>
								),
								children: [
									// {
									// 	path: "/course/certificates",
									// 	element: <ModalCertificates />,
									// },
								],
							},
							{
								path: "/course/course-details",
								element: (
									<PrivateRoute>
										<CourserunDetail />
									</PrivateRoute>
								),
							},
							{
								path: "/course/upcoming-course-info",
								element: (
									<PrivateRoute>
										<CourserunDetail />
									</PrivateRoute>
								),
							},
							{
								path: "/course/reschedule",
								element: (
									<PrivateRoute>
										<ModalReschedule />
									</PrivateRoute>
								),
							},
							{
								path: "/course/reschedule_description",
								element: (
									<PrivateRoute>
										<ModalRescheduleDesc />
									</PrivateRoute>
								),
							},
							{
								path: "/course/withdrawal",
								element: (
									<PrivateRoute>
										<ModalWithdrawal />
									</PrivateRoute>
								),
							},
							{
								path: "/course/withdrawal_description",
								element: (
									<PrivateRoute>
										<ModalWithdrawalDesc />
									</PrivateRoute>
								),
							},
							{
								path: "/course/course-info/:id",
								element: (
									<PrivateRoute>
										<ModalCourseInfo />
									</PrivateRoute>
								),
							},
							{
								path: "/course/shuttle-bus",
								element: (
									<PrivateRoute>
										<ModalShuttleBus />
									</PrivateRoute>
								),
							},
							{
								path: "/course/bundle/:id",
								element: (
									<PrivateRoute>
										<ModalBundleInfo />
									</PrivateRoute>
								),
							},
							{
								path: "/course/bundle-list/:id",
								element: (
									<PrivateRoute>
										<ModalBundleList />
									</PrivateRoute>
								),
							},
							{
								path: "/course/download-resources",
								element: (
									<PrivateRoute>
										<ModalDownloadResources />
									</PrivateRoute>
								),
							},
							{
								path: "/course/resource-details/:id",
								element: (
									<PrivateRoute>
										<ModalResourceDetails />
									</PrivateRoute>
								),
							},
							{
								path: "/course/register",
								element: (
									<PrivateRoute>
										<ModalRegistration />
									</PrivateRoute>
								),
							},
							{
								path: "/course/payment",
								element: (
									<PrivateRoute>
										<ModalPayment />
									</PrivateRoute>
								),
							},
							{
								path: "/course/endorse",
								element: (
									<PrivateRoute>
										<ModalEndorse />
									</PrivateRoute>
								),
							},
							{
								path: "/course/confirm",
								element: (
									<PrivateRoute>
										<ModalConfirm />
									</PrivateRoute>
								),
							},
							{
								path: "/course/success",
								element: (
									<PrivateRoute>
										<ModalSuccess />
									</PrivateRoute>
								),
							},
							{
								path: "/contact-us",
								element: (
									<PrivateRoute>
										<ContactUs />
									</PrivateRoute>
								),
							},
							{
								path: "/enquiry",
								element: (
									<PrivateRoute>
										<ContactUs2 />
									</PrivateRoute>
								),
							},
							{
								path: "/course/meal-selection",
								element: (
									<PrivateRoute>
										<ModalMealSelection />
									</PrivateRoute>
								),
							},
							{
								path: "/course/success-page",
								element: (
									<PrivateRoute>
										<SuccessPage />
									</PrivateRoute>
								),
							},
							// events
							// {
							// 	path: "events",
							// 	element:  <NewsLayout />,
							// 	children: [
							// 		{
							// 			path: "",
							// 			element: (<NewsHomeScreen />),
							// 		},
							// 		// {
							// 		// 	path: "daily",
							// 		// 	element: <DailyNews />,
							// 		// },
							// 		// {
							// 		// 	path: "/news/article/:id",
							// 		// 	element: <DailyNewsDetails />,
							// 		// },
							// 		// {
							// 		// 	path: "/news/event/:id",
							// 		// 	element: <EventDetails />,
							// 		// },
							// 		// {
							// 		// 	path: "teaser",
							// 		// 	element: <Teaser />,
							// 		// },
							// 		// {
							// 		// 	path: "/news/teaser/:id",
							// 		// 	element: <TeasersDetails />,
							// 		// },
							// 	],
							// },
							{
								path: "/events",
								element: <EventHome />,
							},
							// {
							// 	path: "/news/daily",
							// 	element: <DailyNews />,
							// },
							// {
							// 	path: "/news/article/:id",
							// 	element: <DailyNewsDetails />,
							// },
							{
								path: "/events/:id",
								element: <EventDetails />,
							},
							{
								path: "upskilling100",
								element: <VideoHome />,
							},

							// {
							// 	path: "/news/teaser",
							// 	element: <Teaser />,
							// },
							// {
							// 	path: "/news/teaser/:id",
							// 	element: <TeasersDetails />,
							// },
							// notification
							{
								path: "notification",
								element: (
									<PrivateRoute>
										<NotificationMain />
									</PrivateRoute>
								),
							},
							{
								path: "/notification/:id",
								element: (
									<PrivateRoute>
										<NotificationDetails />
									</PrivateRoute>
								),
							},
							{
								path: "/notification/article/:id",
								element: (
									<PrivateRoute>
										<ArticleReply />
									</PrivateRoute>
								),
							},
							// FAQ
							{
								path: "faq",
								element: (
									<PrivateRoute>
										<FaqMain />
									</PrivateRoute>
								),
							},
							//Profile
							{
								path: "profile",
								element: (
									<PrivateRoute>
										<Profile />
									</PrivateRoute>
								),
							},
							{
								path: "profile/edit",
								element: (
									<PrivateRoute>
										<ProfileEdit />
									</PrivateRoute>
								),
							},
							{
								path: "profile/change-password",
								element: (
									<PrivateRoute>
										<ProfileChangePassword />
									</PrivateRoute>
								),
							},
							{
								path: "profile/change-password/otp-validation",
								element: (
									<PrivateRoute>
										<ProfileChangePasswordOtpValidation />
									</PrivateRoute>
								),
							},
							{
								path: "profile/change-email",
								element: (
									<PrivateRoute>
										<ProfileChangeEmail />
									</PrivateRoute>
								),
							},
							{
								path: "profile/change-email/otp-validation",
								element: (
									<PrivateRoute>
										<ProfileChangeEmailOtpValidation />
									</PrivateRoute>
								),
							},
							{
								path: "profile/delete-account",
								element: <ProfileDeleteAccount />,
							},
							{
								path: "profile/delete-account/otp-validation",
								element: <ProfileDeleteAccountOtpValidation />,
							},
							{
								path: "/course/meal-selection",
								element: <ModalMealSelection />,
							},
							{
								path: "/course/success-page",
								element: <SuccessPage />,
							},
							// alumni referral
							// {
							// 	path: "referral",
							// 	element: (<PrivateRoute><ReferralDashboard /></PrivateRoute>),
							// },
							// avatar
							{
								path: "avatar",
								element: (
									<PrivateRoute>
										<AvatarScreen />
									</PrivateRoute>
								),
							},
							{
								path: "/certification",
								element: (
									<PrivateRoute>
										<ListingPage />
									</PrivateRoute>
								),
							},
							{
								path: "/professional-cert/create",
								element: (
									<PrivateRoute>
										<CreatePage />
									</PrivateRoute>
								),
							},
							{
								path: "/certification/view-cert",
								element: (
									<PrivateRoute>
										<ViewCert />
									</PrivateRoute>
								),
							},
							{
								path: "/cert_orders",
								element: <CertRequestPage />,
							},
						],
					},
					// professional cert checkout
					{
						path: "/professional-cert/appCheckout",
						element: <ProfessionalCertAppCheckoutPage />,
					},
					{
						path: "/professional-cert/checkout/omise",
						children: [
							{
								path: "paynow",
								element: <ProfessionalCertOmisePaynow />,
							},
							{
								path: "loading",
								element: <ProfessionalCertOmiseloading />,
							},
						],
					},
					{
						path: "/professional-cert/checkout",
						element: (
							<Sentry.ErrorBoundary fallback={<ErrorFallback />}>
								<ProfessionalCertCheckout />
							</Sentry.ErrorBoundary>
						),
						children: [
							{
								path: "omise/paynow",
								element: <ProfessionalCertOmisePaynow />,
							},
							{
								path: "omise/loading",
								element: <ProfessionalCertOmiseloading />,
							},

							// TOOD: CONTINUE HERE , fix the success route get override by the summary page
							{
								path: "success",
								element: <ProfessionalCertCheckoutSuccessPage />,
							},
							{
								path: "",
								element: <ProfessionalCertCheckoutSummaryPage />,
							},
						],
					},

					// error page
					{
						path: "/maintenance",
						element: <MaintenancePage />,
					},
					// checkout
					{
						path: "/checkout",
						element: (
							<Sentry.ErrorBoundary fallback={<ErrorFallback />}>
								<CheckoutPage />
							</Sentry.ErrorBoundary>
						),
						children: [
							{
								path: "",
								element: <Navigate to="account" />,
							},
							{
								path: "account",
								element: <CheckoutRegisterPage />,
							},
							{
								path: "course",
								element: <CheckoutCourseSummaryPage />,
							},
							// {
							// 	path: "omise/",
							// 	element: <OmisePage />,
							// },
							{
								path: "omise/paynow",
								element: <Omisepaynow />,
							},
							{
								path: "omise/loading",
								element: <Omiseloading />,
							},
							{
								// path: "success",
								// element: <Omisesuccess />,
								path: "success",
								element: <CheckoutSuccessPage />,
							},
						],
					},
					// auth
					{
						path: "/event/appCheckout",
						element: <EventAppCheckoutPage />,
					},
					{
						path: "/event/checkout",
						element: (
							<Sentry.ErrorBoundary fallback={<ErrorFallback />}>
								<EventCheckout />
							</Sentry.ErrorBoundary>
						),
						children: [
							{
								path: "",
								element: <EventCheckoutSummaryPage />,
							},
							{
								path: "omise/paynow",
								element: <EventOmisePaynow />,
							},
							{
								path: "omise/loading",
								element: <EventOmiseloading />,
							},
							{
								path: "success",
								element: <EventCheckoutSuccessPage />,
							},
						],
					},
					{
						path: "/event/checkout/omise",
						children: [
							{
								path: "paynow",
								element: <Omisepaynow />,
							},
							{
								path: "loading",
								element: <EventOmiseloading />,
							},
						],
					},
					{
						path: "/login-by-session",
						element: <LoginBySession />,
					},
					{
						path: "/login",
						element: (
							<Sentry.ErrorBoundary fallback={<ErrorFallback />}>
								<AuthLayout />
							</Sentry.ErrorBoundary>
						),
						children: [
							{
								path: "/login",
								element: <Login />,
								children: [
									{ path: "otp-validation", element: <OTPModal /> },
									{ path: "hyperadmin-otp-validation", element: <HyperAdminOtpModal /> },
								],
							},
							{
								path: "hyperadmin-user-selection",
								element: <HyperAdminUserSelection />,
							},
							{
								path: "reset-password",
								element: <ResetPassword />,
							},
							{
								path: "reset-password/otp-validation",
								element: <ResetPasswordOtpValidation />,
							},
							// {
							// 	path: "first-time-reset-password",
							// 	element: <ModalFirstTimeResetPassword />,
							// },
						],
					},
					{
						path: "/register",
						element: (
							<Sentry.ErrorBoundary fallback={<ErrorFallback />}>
								<AuthLayout mobileAlwaysShown />
							</Sentry.ErrorBoundary>
						),
						children: [
							{
								path: "/register",
								element: <Register />,
							},
						],
					},
					// others
					{
						path: "/course/meal-success-page",
						element: (
							<PrivateRoute>
								<MealSuccessPage />
							</PrivateRoute>
						),
					},
					{
						path: "/course/shuttle-bus-success-page",
						element: (
							<PrivateRoute>
								<ShuttleBusSuccessPage />
							</PrivateRoute>
						),
					},
					{
						path: "*",
						element: <ErrorFallback />,
					},

					//{
					//    path: '/',
					//    element: <RootLayout />,
					//    children: [
					//      {
					//        path: '/',
					//        element: <Posts />,
					//        children: [{ path: '/create-post', element: <NewPost /> }],
					//      },
					//    ],
					//  },
			  ],
	},
	// Mobile redirect routes - redirect to maintenance if maintenance mode is enabled
	{
		path: "/mobile/redirect/success",
		element: MAINTENANCE_MODE ? <Navigate to="/maintenance" replace /> : <MobileRedirectSuccess />,
	},
	{
		path: "/mobile/redirect/fail",
		element: MAINTENANCE_MODE ? <Navigate to="/maintenance" replace /> : <MobileRedirectFail />,
	},
];

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

const router = sentryCreateBrowserRouter(route);

export default router;
